<template lang="pug">
  JsonExcel(v-if="origen === 'client'" :data="dataForExcel" type="xls" name="LISTADO_CLIENTES")
    v-btn(color='success' dark )
      | Reporte
  JsonExcel(v-else-if="origen === 'config'" :data="dataForExcel" :ley='ley' type="xls" name="DATA_CLIENTES")
    v-btn(color='success' small dark @click='leyenda')
      v-icon(small) mdi-arrow-collapse-up
      | Clientes
</template>
<script>
import JsonExcel from 'vue-json-excel'
export default {
  props: ['FormPadre', 'origen', 'ley'],
  data: () => ({
    dataForExcel: [],
    form: []
  }),

  components: {
    JsonExcel
  },

  watch: {
    FormPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.generarExcel()
      }
    }
  },
  methods: {
    leyenda () {
      this.$emit('modiLey')
    },

    generarExcel () {
      this.dataForExcel = []
      this.form.map(cliente => {
        Object.keys(cliente).forEach(function (key) {
          if (cliente[key] === undefined || cliente[key] === null) {
            cliente[key] = ''
          }
        })
        if (this.origen === 'client') {
          let tipoCliente = ''
          let ruta = ''
          let estado = ''
          let municipio = ''
          let parroquia = ''
          if (cliente.idTipoCliente) tipoCliente = cliente.idTipoCliente.descripcion
          if (cliente.idRuta) ruta = cliente.idRuta.descripcion
          if (cliente.codEstado) estado = cliente.codEstado.nombre
          if (cliente.codMunicipio) municipio = cliente.codMunicipio.nombre
          if (cliente.codParroquia) parroquia = cliente.codParroquia.nombre

          cliente.nombre ? cliente.nombre : cliente.nombre = ''
          cliente.rif ? cliente.rif : cliente.rif = ''
          cliente.codigo ? cliente.codigo : cliente.codigo = ''
          cliente.telefono ? cliente.telefono : cliente.telefono = ''
          cliente.correo ? cliente.correo : cliente.correo = ''
          cliente.direccion ? cliente.direccion : cliente.direccion = ''
          cliente.telefonos ? cliente.telefonos : cliente.telefonos = ''
          // cliente.contribuyente ? cliente.contribuyente : cliente.contribuyente = ''
          cliente.limiteCredito ? cliente.limiteCredito : cliente.limiteCredito = ''
          cliente.diasCredito ? cliente.diasCredito : cliente.diasCredito = ''
          cliente.codigoSunagro ? cliente.codigoSunagro : cliente.codigoSunagro = ''
          cliente.lat ? cliente.lat : cliente.lat = ''
          cliente.lng ? cliente.lng : cliente.lng = ''
          // cliente.atencion ? cliente.atencion : cliente.atencion = ''
          cliente.canal ? cliente.canal : cliente.canal = ''
          cliente.subcanal ? cliente.subcanal : cliente.subcanal = ''
          // cliente.diasVisitas ? cliente.diasVisitas : cliente.diasVisitas = ''
          // cliente.frecuencia ? cliente.frecuencia : cliente.frecuencia = ''
          // cliente.representante1 ? cliente.representante1 : cliente.representante1 = ''
          // cliente.representante2 ? cliente.representante2 : cliente.representante2 = ''
          // cliente.correo1 ? cliente.correo1 : cliente.correo1 = ''
          // cliente.correo2 ? cliente.correo2 : cliente.correo2 = ''
          // cliente.telefono1 ? cliente.telefono1 : cliente.telefono1 = ''
          // cliente.telefono2 ? cliente.telefono2 : cliente.telefono2 = ''
          // cliente.fechaCreacion ? cliente.fechaCreacion : cliente.fechaCreacion = ''
          cliente.estatus ? cliente.estatus : cliente.estatus = ''

          let fila = {
            'NOMBRE COMERIAL': `${cliente.nombre}`,
            'RIF': `${cliente.rif}`,
            'CÓDIGO': `${cliente.codigo}`,
            'TELEFONO': `${cliente.telefono}`,
            'CORREO': `${cliente.correo}`,
            'DIRECCIÓN': `${cliente.direccion}`,
            'TELEFONOS': `${cliente.telefonos}`,
            // 'CONTRIBUYENTE': `${cliente.contribuyente}`,
            'TIPO DE CLIENTE': `${tipoCliente}`,
            'LÍMITE DE CRÉDITO': `${cliente.limiteCredito}`,
            'DÍAS DE CRÉDITO': `${cliente.diasCredito}`,
            'CÓDIGO SUNAGRO': `${cliente.codigoSunagro}`,
            'ESTADO': `${estado}`,
            'MUNICIPIO': `${municipio}`,
            'PARROQUIA': `${parroquia}`,
            'LATITUD': `${cliente.lat}`,
            'LONGITUD': `${cliente.lng}`,
            'RUTA': `${ruta}`,
            // 'ATENCIÓN': `${cliente.atencion}`,
            'CANAL': `${cliente.canal}`,
            'SUB CANAL': `${cliente.subcanal}`,
            // 'DÍAS DE VISITA': `${cliente.diasVisitas}`,
            // 'FRECUENCIA DE VISITA': `${cliente.frecuencia}`,
            // 'REPRESENTANTE 1': `${cliente.representante1}`,
            // 'CORREO 1': `${cliente.correo1}`,
            // 'TELEFONO 1': `${cliente.telefono1}`,
            // 'REPRESENTANTE 2': `${cliente.representante2}`,
            // 'CORREO 2': `${cliente.correo2}`,
            // 'TELEFONO 2': `${cliente.telefono2}`,
            'FECHA DE REGISTRO': `${cliente.fechaCreacion}`,
            'ÉSTATUS': `${cliente.estatus}`
          }
          this.dataForExcel.push(fila)
        } else if (this.origen === 'config') {
          let fila = {
            'nombre': ``,
            'rif': ``,
            'codigo': ``,
            'telefono': ``,
            'correo': ``,
            'direccion': ``,
            'telefono': ``,
            // 'contribuyente': ``,
            'limiteCredito': ``,
            'diasCredito': ``,
            'codigoSunagro': ``,
            'latitud': ``,
            'longitud': ``,
            // 'atencion': ``,
            'canal': ``,
            'subcanal': ``,
            // 'diasVisitas': ``,
            // 'frecuencia': ``,
            // 'representante1': ``,
            // 'correo1': ``,
            // 'telefono1': ``,
            // 'representante2': ``,
            // 'correo2': ``,
            // 'telefono2': ``
          }
          this.dataForExcel.push(fila)
        }
      })
    }
  }
}
</script>
